export default __webpack_public_path__ + "static/media/ciduMarket.66a2cdd3.svg";